import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["employees", "final", "discount"]

  connect() {
    // Parse course data and initialize calculator
    this.parseCourseData()
    this.findTargetsManually()
    // Initial calculation without delay
    this.performCalculation()
  }

  findTargetsManually() {
    // Find targets manually since they might be in hidden tabs
    this.employeesElement = this.element.querySelector('[data-pricing-calculator-target="employees"]')
    this.finalElement = this.element.querySelector('[data-pricing-calculator-target="final"]')
    this.discountElement = this.element.querySelector('[data-pricing-calculator-target="discount"]')
  }

  parseCourseData() {
    const rawValue = this.element.dataset.pricingCalculatorCourseValue
    
    try {
      // Clean the value first by removing extra escapes
      const cleanValue = rawValue.replace(/\\"/g, '"')
      this.courseData = JSON.parse(cleanValue)
    } catch (error) {
      // Try alternative parsing method
      try {
        this.courseData = JSON.parse(rawValue)
      } catch (error2) {
        this.courseData = null
      }
    }
  }

  updateCalculation() {
    // Show loading state immediately when user changes selection
    this.showLoadingState()
    
    // Simulate calculation delay for better UX feedback
    setTimeout(() => {
      this.performCalculation()
    }, 500)
  }
  
  showLoadingState() {
    const finalEl = this.finalElement || this.finalTarget
    const discountEl = this.discountElement || this.discountTarget
    
    if (finalEl) {
      finalEl.innerHTML = '<span class="inline-flex items-center justify-center"><svg class="animate-spin h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></span>'
    }
    if (discountEl) {
      discountEl.innerHTML = '<span class="inline-flex items-center justify-center"><svg class="animate-spin h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></span>'
    }
  }

  performCalculation() {
    // Ensure we have course data (parse if needed)
    if (!this.courseData) {
      this.parseCourseData()
    }
    
    const hasData = !!this.courseData
    const hasTargets = !!(this.employeesElement || this.hasEmployeesTarget)
    
    if (!hasData || !hasTargets) {
      return
    }

    const employeesEl = this.employeesElement || this.employeesTarget
    const selectedEmployeeIndex = Number(employeesEl.value)
    
    // Employee discount percentages for FUNDAE
    const employees = [0, 5, 10, 20, 40]
    const discountPercent = employees[selectedEmployeeIndex]
    
    const bonus = this.getBonus(this.courseData.fundae_hours, parseFloat(this.courseData.price), discountPercent)
    const final = parseFloat(this.courseData.price) - bonus.bonus

    // Update UI with calculated results
    const finalEl = this.finalElement || this.finalTarget
    const discountEl = this.discountElement || this.discountTarget
    
    if (finalEl) {
      finalEl.textContent = final.toLocaleString() + '€'
    }
    if (discountEl) {
      discountEl.textContent = bonus.discount.toLocaleString(undefined, { style: "percent" })
    }
  }

  getBonus(hours, price, financing) {
    const FACTORHORAS = 7.5
    const bonus = Math.min(
      hours * FACTORHORAS,
      price * (1 - this.toPercent(financing))
    )
    const discount = bonus / price

    return { bonus, discount }
  }

  toPercent(percent) {
    if (typeof percent === "string") percent = parseInt(percent)
    if (percent < 0) percent = 0
    if (percent > 1 && percent < 100) percent = percent / 100
    return percent
  }
} 
